// import core & vendor packages below
import React from 'react';
import { createRoot } from 'react-dom/client';
import { store } from './app/store';
import { Provider } from 'react-redux';

// import components below
import App from './App';

// import assets below
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/sass/main.scss';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
